import React from "react";
import { cn } from "../../lib/cn";

/**
 * Replaces antd Button: type primary|default|dashed|ghost|link,
 * danger flag, icon slot, htmlType, loading
 */
export function Button({
  children,
  className,
  variant,
  type = "default",
  htmlType = "button",
  disabled,
  loading,
  danger,
  icon,
  size,
  ...props
}) {
  let inferred = variant || null;
  if (!inferred) {
    inferred =
      danger || type === "danger"
        ? "danger"
        : type === "primary"
          ? "primary"
          : type === "link" || type === "text"
            ? "subtle"
            : type === "dashed"
              ? "dashed"
              : type === "ghost"
                ? "ghost"
                : type === "default"
                  ? "default"
                  : "ghost";
  }

  const variants = {
    primary:
      "bg-brand text-white shadow-sm hover:bg-brand-dark disabled:opacity-50",
    ghost: "bg-white border border-slate-200 text-slate-800 hover:bg-slate-50",
    danger:
      "bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 border-transparent",
    dashed:
      "border border-dashed border-slate-300 bg-white text-slate-800 hover:border-brand hover:text-brand",
    outline:
      "border border-brand text-brand hover:bg-brand-surface bg-white",
    subtle: "text-brand font-semibold hover:underline bg-transparent border-0 px-2",
    default: "border border-slate-200 bg-white text-slate-800 hover:bg-slate-50",
  };

  const isLinkish = type === "link" || type === "text";

  return (
    <button
      type={htmlType}
      disabled={disabled || loading}
      className={cn(
        !isLinkish &&
          "inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition",
        !isLinkish &&
          (size === "large"
            ? "px-5 py-3 text-base"
            : size === "small"
              ? "px-3 py-1.5 text-xs"
              : "px-4 py-2 text-sm"),
        isLinkish &&
          "inline-flex items-center gap-2 rounded-lg bg-transparent px-2 py-1 text-sm font-semibold ring-0 text-slate-700 hover:bg-slate-100",
        variants[inferred] || variants.default,
        className
      )}
      {...props}
    >
      {loading ? (
        <span className="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent" />
      ) : null}
      {!loading && icon ? <span className="inline-flex shrink-0">{icon}</span> : null}
      {children}
    </button>
  );
}
